<template>
  <div class="login stage-page">
    <div class="bg"></div>
    <div class="grid-lines"></div>
    <div class="sweep"></div>

    <!-- 顶部左上角公共 logo（链接回首页，兼并原“返回首页”） -->
    <div class="stage-top">
      <router-link class="logo" :to="{ name: 'Home' }" title="返回首页">
        <span class="mark"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2" /><path d="M7 12h2M8 11v2M15 11h.01M18 13h.01" /></svg></span>
        游<b>选</b>
      </router-link>
    </div>

    <!-- 居中合体白卡 -->
    <div class="auth-wrap">
      <div class="auth-card">
        <!-- 左：深炭品牌面 -->
        <aside class="brand">
        <span class="gln"></span>
        <span class="glyph">YX</span>
        <img class="brand-logo" src="@/assets/logo/logo_horizontal_white.svg" alt="游选" />
        <p class="eyebrow">SECURE TRADING</p>
        <h2 class="slogan">找回包赔<br /><em>秒发交付</em></h2>
        <div class="promises">
          <div class="pm">
            <span class="ic">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z" />
                <path d="M9 12l2 2 4-4" />
              </svg>
            </span>
            <span class="tx"><b>100%</b>账号被找回 · 全额赔付</span>
          </div>
          <div class="pm">
            <span class="ic">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 12a9 9 0 1 1-3-6.7M21 3v5h-5" />
                <path d="M12 8v4l3 2" />
              </svg>
            </span>
            <span class="tx"><b>10 分钟</b>付款后极速交付换绑</span>
          </div>
          <div class="pm">
            <span class="ic">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 12l2 2 4-5" />
                <rect x="3" y="4" width="18" height="16" rx="2" />
              </svg>
            </span>
            <span class="tx"><b>正规</b>电子合同 · 实名担保</span>
          </div>
          <div class="pm">
            <span class="ic">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 9V5a3 3 0 0 0-6 0v4M5 9h14l1 11H4z" />
              </svg>
            </span>
            <span class="tx"><b>368,520+</b>笔交易全程站内担保</span>
          </div>
        </div>
        </aside>

        <!-- 右：白卡表单面 -->
        <div class="form-panel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="忘记密码" name="forgetPwd">
          <div class="forgetPwd_box box">
            <el-form :model="forgetPwdForm" :rules="forgetPwdRules" ref="forgetPwdForm" class="forgetPwdForm">
              <el-form-item  prop="phone" class="pwd">
<!--                <el-input placeholder="请输入手机号"  v-model.trim="forgetPwdForm.phone">-->
<!--                  <i slot="prefix"> <img src="@/assets/image/Login/loginAccount.png" alt=""></i>-->
<!--                </el-input>-->
                <country-code :phone="forgetPwdForm.phone" @phoneChange="(val)=>{forgetPwdForm.phone = val.trim()}"
                              @codeChange="(val)=>{forgetPwdForm.countryCode = val}"></country-code>
              </el-form-item>
              <el-form-item  prop="smsCode" class="smsCode">
                <inputPwd placeholder="请输入验证码" :pwd="forgetPwdForm.smsCode" @inputChange="(val)=>{forgetPwdForm.smsCode = val}"></inputPwd>
                <span v-if="smsCode" class="getSmsCode" @click="smsSend(forgetPwdForm.phone)">获取验证码</span>
                <span v-else class="getSmsCode" id="smsFalse">{{ smsTime }}秒后重发</span>
              </el-form-item>
              <el-form-item  prop="pwd" class="pwd">
                <inputPwd placeholder="请修改登录密码" :pwd="forgetPwdForm.pwd" @inputChange="(val)=>{forgetPwdForm.pwd = val}"></inputPwd>
              </el-form-item>
              <el-form-item  prop="pwd_confirm" class="pwd_confirm">
                <inputPwd placeholder="请确认登录密码" :pwd="forgetPwdForm.pwd_confirm" @inputChange="(val)=>{forgetPwdForm.pwd_confirm = val}"></inputPwd>
              </el-form-item>
              <el-form-item class="forgetPwdSubmit">
                <el-button type="primary" @click="R_submitForm('forgetPwdForm')">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="登录" name="password_login">
          <div class="password_login_box box">
            <el-form :model="loginForm"  ref="loginForm" class="loginForm" :rules="loginFormRules">
              <el-form-item  prop="phone" class="pwd">
                <el-input placeholder="请输入手机号" v-model.trim="loginForm.phone">
                  <i slot="prefix"> <img src="@/assets/image/Login/loginAccount.png" alt=""></i>
                </el-input>
              </el-form-item>
              <el-form-item  prop="pwd" class="pwd">
                <inputPwd placeholder="请输入密码" :pwd="loginForm.pwd" @inputChange="(val)=>{loginForm.pwd = val}"></inputPwd>
              </el-form-item>
              <el-form-item  prop="autoLogin" class="autoLogin">
                <div>
                  <el-checkbox v-model="loginForm.autoLogin">记住我</el-checkbox>
                </div>
                <div>
                  <span @click="activeName ='forgetPwd'">忘记密码</span>
                  &nbsp;丨&nbsp;
                  <router-link tag="span" :to="{name:'Register'}">注册</router-link>
                </div>
              </el-form-item>
              <el-form-item class="loginSubmit">
                <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
        </div>
      </div>
    </div>

    <!-- 备案页脚 -->
    <footer class="stage-foot">
      <div class="row">
        <a
          class="police-record"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33070302100220"
          >浙公网安备 33070302100220号</a
        >
        <a href="https://images.pxb7.com/icp.jpg" target="_blank"
          >浙B2-20210138</a
        >
        <a href="https://images.pxb7.com/zhizhao1.pdf" target="_blank"
          >电子营业执照</a
        >
      </div>
      <div>©版权所有 游选游戏服务网 All Rights Reserved</div>
    </footer>
  </div>
</template>
<script>
import {apiBind, apiLogin, apiReset, apiSmsSend} from '@/request/API';
import vuex from "@/store";
import inputPwd from "@/components/inputPwd";
import CountryCode from "@/components/countryCode";

export default {
  name: '',
  props: {
  },
  components: {
    CountryCode,
    inputPwd
  },
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.forgetPwdForm.pwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      //tabbar click
      activeName: 'forgetPwd',
      //阅读并同意
      read_checked:false,
      //下次自动登录
      checked:false,
      //注册表单
      forgetPwdForm: {
        phone: '',
        smsCode: '',
        pwd: '',
        pwd_confirm: '',
        countryCode:'86',
        agreement:[]
      },
      forgetPwdRules: {
        phone:[
          { required: true, message: '请输入手机号', trigger: 'blur' },
          // { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        smsCode:[
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        pwd: [
          { required: true, message: '请修改登录密码', trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: '密码由8到16位数字和字母组成' }
        ],
        pwd_confirm: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      //登陆表单
      loginForm: {
        phone: '',
        pwd: '',
        autoLogin:''
      },
      loginFormRules:{
        phone:[
          { required: true, message: '请输入手机号', trigger: 'blur' },
          // {pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      //获取验证码
      smsCode:true,
      smsTime:60,
      passwordType:'password'
    }
  },
  methods: {
    /**
     *  忘记密码
     */
    R_submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apiReset({
            phone:this.forgetPwdForm.phone,
            pwd:this.forgetPwdForm.pwd,
            pwd_confirm:this.forgetPwdForm.pwd_confirm,
            smsCode:this.forgetPwdForm.smsCode,
            country_code:this.forgetPwdForm.countryCode,
          }).then(res => {
            this.$message({
              message:"修改密码成功",
              center:true,
              type:"success"
            })
            this.activeName ='password_login'
          }).catch(err=>{
            this.$message({
              message:err.msg,
              center:true,
              type:"error"
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClick(tab, event) {
    },
    /**
     * tabbar切换
     */
    changeActiveName(){
      this.activeName ='forgetPwd'
    },
    /**
     * 获取验证码
     * @param phone
     */
    smsSend(phone){
      if (!phone) {
        this.$message({
          type: "error",
          center: true,
          message:'请输入手机号码以获取验证码'
        })
        return
      }
      apiSmsSend({
        phone:phone,
        codeType:this.forgetPwdForm.countryCode == '86'?0:12,
        country_code:this.forgetPwdForm.countryCode
      }).then(res => {
        this.$message({
          type:"success",
          center:true,
          message:"发送成功"
        })
        this.smsCode = false
      }).catch(err=>{
        this.$message({
          type:"error",
          center:true,
          message:err.msg
        })
      })

    },
    /**
     * 登录
     * @param phone
     * @param pwd
     */
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          localStorage.removeItem('sby_userid')
          localStorage.removeItem('cusetomerTokens')
          localStorage.removeItem('cusetomerSid')
          localStorage.removeItem('roomId')
          // 判断是否需要记住密码
          if (this.forgetPwdForm.autoLogin) {
            // 传入账号名，密码，记住我,保存天数
            this.setCookie(this.account, this.password, this.forgetPwdForm.autoLogin,7)
          } else {
            // 清空Cookie
            this.clearCookie()
          }
          apiLogin({
            phone:this.loginForm.phone,
            pwd:this.loginForm.pwd
          }).then(res => {
            this.token=res.data.token
            this.refresh_token = res.data.refresh_token
            let status = true
            this.$store.commit('set_token',this.token)
            this.$store.commit('set_refresh_token', this.refresh_token)
            this.$store.commit('set_userData',res.data)
            this.$store.commit('set_loginStatus',status)
            this.$store.state.loginStatus = true
            this.$store.state.userData = res.data
            setTimeout(() => {
              sby_setuserid(this.$store.state.userData.telphone, this.$store.state.userData.nickname, this.$store.state.userData.avatar == '' ? 'https://m.pxb7.com/image/public/avatar.jpg' :this.$store.state.userData.avatar)
            },400)
            // var api53 = $53.createApi()
            // api53.push('cmd', 'member');
            // api53.push('id',this.$store.state.userData.user_id);
            // api53.push('name',this.$store.state.userData.nickname);
            // api53.query();
            if(!this.$route.query.Rurl){
              this.$router.push({
                path:'/'
              });
            }else{
              this.$router.push({
                path:this.$route.query.Rurl
              })
            }
          }).catch(err=>{
            this.$message({
              message: err.msg,
              type: 'error',
              center: true
            });
            this.password = ''
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //获取验证码冷却
    countdownTime(){
      this.smsTime--
      if(this.smsTime === 0){
        this.smsCode = true
      }
    },
    // 设置cookie
    setCookie(name, pwd, remeber, exdays) {
      var now= new Date() // 获取时间
      now.setTime(now.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie' ;toGMTString() 方法可根据格林威治时间 (GMT) 把 Date 对象转换为字符串，并返回结果
      window.document.cookie = 'userName' + '=' + name + ';time=' + now.toGMTString()
      window.document.cookie = 'userPwd' + '=' + pwd + ';time=' + now.toGMTString()
      window.document.cookie = 'remeber' + '=' + remeber + ';time=' + now.toGMTString()
    },
    // 读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') // 这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') // 再次切割
          // 判断查找相对应的值
          if (arr2[0] === 'userName') {
            this.account = arr2[1] // 保存到保存数据的地方
          } else if (arr2[0] === 'userPwd') {
            this.password = arr2[1]
          } else if (arr2[0] === 'remeber') {
            if (arr2[1] === 'true') {
              this.forgetPwdForm.autoLogin = true
            }else {
              this.forgetPwdForm.autoLogin = false
            }
          }
        }
      }
    },
    // 清除cookie
    clearCookie: function() {
      this.setCookie('', '','', -1) // 修改2值都为空，天数为负1天就好了
    }
  },
  mounted () {
    this.getCookie()
  },
  watch: {
    smsCode(val, oldVal){//普通的watch监听
      if(!val){
        this.smsTime = 60
        this.countdown = setInterval(this.countdownTime, 1000);
      }else{
        clearInterval(this.countdown)
      }
    },
  },
  computed: {

  },
  created() {
    let g = this;
    document.onkeydown = function (e){
      let key = window.event.keyCode;
      if (!vuex.state.loginStatus) {
        if (key == 13) {
          if (g.activeName == 'forgetPwd') {
            g.R_submitForm('forgetPwdForm')
          } else {
            g.submitForm('loginForm')
          }
        }
      }
    }
  }
}
</script>

<style lang='less' scoped>
/deep/.el-form-item__error{
  padding-top: 0;
}
/deep/ .el-tabs__header.is-top{
  margin: 0 0 24px 0;
}
/deep/.el-tabs__nav.is-top{
  margin-left: 0;
}
/deep/.el-tabs__item{
  position: relative;
  padding: 0 22px;
  height: 38px;
  line-height: 38px;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: var(--text-secondary);
  background: transparent;
}
/deep/.el-tabs__item::before{
  content: "";
  position: absolute;
  inset: 0;
  background: var(--bg-tag);
  transform: skewX(-12deg);
  border-radius: 2px;
  z-index: -1;
}
/deep/.el-tabs__item.is-active{
  color: #fff;
}
/deep/.el-tabs__item.is-active::before{
  background: var(--bg-dark);
}
/deep/.el-tabs__item.is-active::after{
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background: var(--primary);
}
/deep/.el-tabs__nav-wrap::after{
  height: 0;
  background: transparent;
}
/deep/.el-tabs__active-bar.is-top{
  height: 0;
}
/deep/.el-tabs__active-bar{
  height: 0;
}
.login {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--bg-stage);
  overflow: hidden;

  .bg {
    position: absolute;
    inset: 0;
    background: radial-gradient(
        120% 90% at 82% 6%,
        rgba(255, 90, 31, 0.16),
        transparent 55%
      ),
      linear-gradient(115deg, #171b22 0%, #0e1116 60%, #1d1410 100%);
  }

  .grid-lines {
    position: absolute;
    inset: 0;
    background-image: linear-gradient(
        rgba(255, 255, 255, 0.03) 1px,
        transparent 1px
      ),
      linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
    background-size: 40px 40px;
    -webkit-mask-image: radial-gradient(
      120% 80% at 50% 30%,
      #000,
      transparent 78%
    );
    mask-image: radial-gradient(120% 80% at 50% 30%, #000, transparent 78%);
  }

  .sweep {
    position: absolute;
    top: 0;
    left: -40%;
    width: 26%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.04),
      transparent
    );
    transform: skewX(-20deg);
    animation: sweep 2.8s var(--ease) infinite;
    z-index: 1;
  }

  @keyframes sweep {
    0% {
      left: -40%;
    }
    60%,
    100% {
      left: 130%;
    }
  }

  .stage-top {
    position: relative;
    z-index: 2;
    padding: 26px 32px;

    .logo {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      color: #fff;
      font-weight: 900;
      font-size: 26px;
      letter-spacing: -1px;

      .mark {
        width: 38px;
        height: 38px;
        background: var(--primary);
        display: flex;
        align-items: center;
        justify-content: center;
        transform: skewX(-12deg);
        border-radius: 3px;
      }

      .mark svg {
        transform: skewX(12deg);
      }

      b {
        color: var(--primary);
      }
    }
  }

  .auth-wrap {
    position: relative;
    z-index: 2;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px 40px;
  }

  .auth-card {
    display: grid;
    grid-template-columns: 340px 1fr;
    width: 100%;
    max-width: 880px;
    background: var(--bg-card);
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  }

  .brand {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 38px 34px;
    background: var(--bg-dark);
    overflow: hidden;
  }

    .brand .gln{
      position: absolute;
      inset: 0;
      background-image: linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
      background-size: 36px 36px;
      -webkit-mask-image: linear-gradient(180deg, transparent, #000 65%);
      mask-image: linear-gradient(180deg, transparent, #000 65%);
    }
    .brand .glyph{
      position: absolute;
      right: -6px;
      bottom: -30px;
      font-style: italic;
      font-weight: 900;
      font-size: 170px;
      color: rgba(255, 255, 255, 0.05);
      line-height: 1;
      z-index: 0;
    }
    .brand .brand-logo{
      position: relative;
      width: 132px;
      height: auto;
      object-fit: contain;
      margin-bottom: 20px;
    }
    .brand .eyebrow{
      position: relative;
      font-size: 11px;
      letter-spacing: 2px;
      color: var(--gold);
      font-weight: 700;
      margin-bottom: 12px;
    }
    .brand .slogan{
      position: relative;
      color: #fff;
      font-size: 28px;
      font-weight: 900;
      letter-spacing: -1px;
      line-height: 1.2;
    }
    .brand .slogan em{
      font-style: normal;
      color: var(--primary);
    }
    .brand .promises{
      position: relative;
      margin-top: auto;
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding-top: 30px;
    }
    .brand .pm{
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .brand .pm .ic{
      width: 34px;
      height: 34px;
      flex: none;
      border: 1px solid #363b45;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--gold);
      transform: skewX(-12deg);
    }
    .brand .pm .ic svg{
      transform: skewX(12deg);
    }
    .brand .pm .tx{
      font-size: 13px;
      color: #aeb4be;
      line-height: 1.4;
    }
    .brand .pm .tx b{
      display: block;
      color: #fff;
      font-size: 16px;
      font-weight: 900;
      letter-spacing: -0.3px;
    }

  .form-panel{
    min-width: 0;
    padding: 24px 34px 30px;
    .box{
      width: 100%;
      margin: 0;
      /deep/.el-input--prefix .el-input__inner{
        height: 50px !important;
        line-height: 50px !important;
        border-radius: 3px;
        padding-left: 56px;
        border: 1px solid var(--border-soft);
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: var(--text-main);
      }
      /deep/.el-input--suffix .el-input__inner{
        height: 50px !important;
        line-height: 50px !important;
        border-radius: 3px;
        padding-left: 56px;
        border: 1px solid var(--border-soft);
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: var(--text-main);
      }
      /deep/.el-input--prefix .el-input__inner::-webkit-input-placeholder{
        color: var(--text-muted);
      }
      /deep/.el-input--suffix .el-input__inner::-webkit-input-placeholder{
        color: var(--text-muted);
      }
      /deep/.el-input{
        margin-bottom: 10px;
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: var(--text-muted);
        line-height: 20px;
      }
      /deep/.el-input__prefix{
        left: 22px;
      }
      /deep/.el-input__inner:focus {
        border-color: var(--primary);
        background: var(--bg-card);
        box-shadow: none;
      }

      /deep/ .countryCode {
        border-color: var(--border-soft);
        border-radius: 3px;
      }

      /deep/ .countryCode:focus-within {
        border-color: var(--primary);
        box-shadow: none;
      }

      /deep/ .countryCode .country-box {
        color: var(--text-main);
      }

      /deep/ .countryCode > span {
        background: var(--border-soft);
      }

      .forgetPwdForm{
        /deep/.el-input__prefix{
          display: flex;
          align-items: center;
        }
        /deep/.el-form-item{
          margin: 0;
        }
        /deep/.el-form-item__error{
          padding: 0;
        }
        .smsCode{
          margin-bottom: 15px;
          /deep/.el-input{
            width: calc(100% - 112px) !important;
            margin-bottom: 5px;
          }
          .getSmsCode{
            display: inline-block;
            width: 100px;
            height: 48px;
            background: var(--bg-dark);
            border-radius: 3px;
            cursor: pointer;
            float: right;
            font-size: 16px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: #ffffff;
            line-height: 22px;
            text-align: center;
            line-height: 48px;
            transition: box-shadow 0.2s ease, filter 0.2s ease;
          }
          .getSmsCode:hover{
            box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
            filter: brightness(1.04);
          }
          #smsFalse{
            background: var(--bg-card-soft);
            color: var(--text-muted);
            cursor: auto;
          }
          #smsFalse:hover{
            box-shadow: none;
            filter: none;
          }
        }
        .pwd{
          margin-bottom: 15px;
          /deep/.el-input{
            margin-bottom: 5px;
          }
        }
        .pwd_confirm{
          margin-bottom: 15px;
          /deep/.el-input{
            margin-bottom: 5px;
          }
        }
        .agreement{
          /deep/.el-checkbox-group{
            line-height: 10px;
          }
          /deep/.el-checkbox__inner{
            width: 16px;
            height: 16px;
            background: var(--bg-section);
            border: 1px solid var(--border-soft);
            border-radius: 3px;
            box-sizing: border-box;
            transition: background-color 0.2s ease, border-color 0.2s ease;
          }
          /deep/.el-checkbox__inner::after{
            height: 7px;
            left: 5px;
            border: 2px solid #FFF;
            border-left: 0;
            border-top: 0;
            top: 2px;
            width: 3px;
          }
          /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
            background: var(--primary);
            border-color: var(--primary);
          }
          /deep/.el-checkbox__label{
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: var(--text-secondary);
            line-height: 20px;
          }
          #coordination{
            font-size: 16px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: var(--primary);
          }
        }
        .forgetPwdSubmit{
          margin: 30px 0 0 0;
          /deep/.el-button{
            width: 100%;
            height: 50px;
            background: var(--primary);
            border-radius: 3px;
            font-size: 24px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            border: none;
            transition: background 0.2s ease;
          }
          /deep/.el-button:hover{
            background: var(--primary-hover);
          }
        }
      }
      .loginForm{
        /deep/.el-input__prefix{
          display: flex;
          align-items: center;
        }
        /deep/.el-form-item{
          margin: 0;
        }
        .pwd{
          margin-bottom: 15px;
          /deep/.el-input{
            margin-bottom: 5px;
          }
        }
        .autoLogin{
          /deep/.el-checkbox__inner{
            width: 16px;
            height: 16px;
            background: var(--bg-section);
            border: 1px solid var(--border-soft);
            border-radius: 3px;
            box-sizing: border-box;
            transition: background-color 0.2s ease, border-color 0.2s ease;
          }
          /deep/.el-checkbox__inner::after{
            height: 7px;
            left: 5px;
            border: 2px solid #FFF;
            border-left: 0;
            border-top: 0;
            top: 2px;
            width: 3px;
          }
          /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
            background: var(--primary);
            border-color: var(--primary);
          }
          /deep/.el-checkbox__label{
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: var(--text-secondary);
            line-height: 20px;
          }
          /deep/.el-form-item__content{
            line-height: 20px;
            display: flex;
            flex-direction: row;
            align-items: baseline;
            div:last-of-type{
              margin-left: 130px;
              font-size: 14px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 300;
              color: var(--text-secondary);
              line-height: 20px;
              span{
                cursor: pointer;
              }
              span:hover{
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                color: var(--primary);
              }
            }
          }
        }
        .loginSubmit{
          margin: 30px 0 ;
          /deep/.el-button{
            width: 100%;
            height: 50px;
            background: var(--primary);
            border-radius: 3px;
            font-size: 24px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            border: none;
            transition: background 0.2s ease;
          }
          /deep/.el-button:hover{
            background: var(--primary-hover);
          }
        }
      }
    }
  }

  .stage-foot {
    position: relative;
    z-index: 2;
    text-align: center;
    padding: 18px 20px 26px;
    color: #5a5f6b;
    font-size: 12px;
    line-height: 1.9;

    .row {
      display: flex;
      justify-content: center;
      gap: 16px;
      flex-wrap: wrap;
    }

    a {
      color: #5a5f6b;
      transition: color 0.2s var(--ease);
    }

    a:hover {
      color: var(--primary);
    }
  }

  @media screen and (max-width: 760px) {
    .auth-card {
      grid-template-columns: 1fr;
      max-width: 440px;
    }

    .brand {
      display: none;
    }

    .form-panel {
      padding: 26px 24px 30px;
    }
  }
}

</style>
